// extracted by mini-css-extract-plugin
export default {"wrapper":"Prices_wrapper__+GCLC","header":"Prices_header__1MFHm","header3":"Prices_header3__QTSqu","pricingContainer":"Prices_pricingContainer__-jlwT"};